import Layout from './components/layout/Layout/Layout';
// import Home from './pages/Home/Home';
import AppRoutes from './routes/AppRoutes';

const App = () => {
  return (
    <Layout>
       <AppRoutes />
    </Layout>
  );
};

export default App;
